import { createSlice } from "@reduxjs/toolkit";

const providerFiltersSlice = createSlice({
  name: "providersFilters",
  initialState: {
    providerIds: [],
    rfiIds: [],
    indications: [],
    providerTypes: [],
    companySizeFiltersId: [],
    selectedRevenueRange: {},
    reportAvailable: {},
    dataAvailability: [],
    countries: [],
    states: [],
    cities: [],
    revenueRangeString: [], // <-- add this line
    searchTextByPage: {}, // Dynamic search text storage for each page
  },
  reducers: {
    setProvidersFilters: (state, action) => {
      state.providerIds = action.payload.providerIds || state.providerIds;
      state.rfiIds = action.payload.rfiIds || state.rfiIds;
      state.indications = action.payload.indications || state.indications;
      state.providerTypes = action.payload.providerTypes || state.providerTypes;
      state.companySizeFiltersId =
        action.payload.companySizeFiltersId || state.companySizeFiltersId;
      state.selectedRevenueRange =
        action.payload.selectedRevenueRange || state.selectedRevenueRange;
      state.reportAvailable =
        action.payload.reportAvailable || state.reportAvailable;
      state.dataAvailability =
        action.payload.dataAvailability || state.dataAvailability;
      state.revenueRangeString =
        action.payload.revenueRangeString || state.revenueRangeString;
      state.countries =
        action.payload.countries || state.countries;
      state.states =
        action.payload.states || state.states;
      state.cities =
        action.payload.cities || state.cities;
    },
    setSearchTextByPage: (state, { payload }) => {
      const { pageKey, searchText } = payload;
      state.searchTextByPage[pageKey] = searchText;
    },
    clearSearchTextByPage: (state, { payload }) => {
      const { pageKey } = payload;
      delete state.searchTextByPage[pageKey];
    },
  },
});

export const {
  setProvidersFilters,
  setSearchTextByPage,
  clearSearchTextByPage,
} = providerFiltersSlice.actions;
export default providerFiltersSlice.reducer;
